import script from "./DeleteBannerButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteBannerButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__